import {Box} from '@mui/material';
import {RichBlock} from '../../types/api';
import React from 'react';
import {
    blockComponents,
    RichBlockComponentProps,
} from './RichBlocks/blockComponents.tsx';

type Props = {
    blocks: (RichBlock & {locale?: string})[];
    locale: string | undefined;
} & Pick<RichBlockComponentProps, 'isPreview' | 'userLocales'>;

export default function RichBlocks({
    isPreview,
    userLocales,
    blocks,
    locale,
}: Props) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                mt: 2,
                px: 2,
            }}
        >
            {blocks.map(s => {
                const component = blockComponents[s.type];

                if (component) {
                    return (
                        <div key={s.id}>
                            {React.createElement(component, {
                                data: s.data,
                                isPreview,
                                userLocales,
                                locale: s.locale ?? locale,
                            })}
                        </div>
                    );
                }

                return null;
            })}
        </Box>
    );
}
